/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { SearchInput } from 'pg-ui-library';
import useDebounceSearchTerm from 'src/hooks/useDebounceSearchTerm';
import { useTranslation } from 'react-i18next';
import { Container, Header, ReportsContainer, Tab, TabContainer, TabTitle, Title } from './styles';
import { ReportsTable } from './components/reports-table';

export enum TABS {
  GENERAL = 'general_reports',
  CUSTOMIZED = 'customized_reports',
}

export const ReportsPage: React.FC = () => {
  const { t } = useTranslation();

  const { searchTerm, setSearchTerm } = useDebounceSearchTerm(500);

  const [selectedTab, setSelectedTab] = useState<TABS>(TABS.GENERAL);

  return (
    <Container>
      <Header>
        <Title>{t('reports.title')}</Title>
        {/*
        <SearchInput
          value={searchTerm}
          placeholder="Search..."
          handleChange={(event) => {
            setSearchTerm(event.target.value);
          }}
        />
        */}
      </Header>
      <ReportsContainer>
        <TabContainer>
          <Tab selected={selectedTab === TABS.GENERAL} onClick={() => setSelectedTab(TABS.GENERAL)}>
            <TabTitle>{t('reports.tab1')}</TabTitle>
          </Tab>
          {/*
            <Tab
              selected={selectedTab === TABS.CUSTOMIZED}
              onClick={() => setSelectedTab(TABS.CUSTOMIZED)}
            >
              <TabTitle>{t('reports.tab2')}</TabTitle>
            </Tab>
          */}
        </TabContainer>
        <ReportsTable />
      </ReportsContainer>
    </Container>
  );
};
